export enum ApplicationActionType {

    InvestmentWelcomeModal = "iwm"
}
